var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-snackbar',{staticClass:"global-snackbar",attrs:{"message":_vm.currentSnackbar.message,"action-text":_vm.currentSnackbar.actionText,"action-url":_vm.currentSnackbar.actionUrl},on:{"action":_vm.executeCurrentSnackbarAction}})}
var staticRenderFns = []

export { render, staticRenderFns }